<template>
    <div id="AccordionCard" class="text-primary">
        <button @click="open = !open" class="">
            <span class="text-sm">{{title}}</span>
            <font-awesome :icon="['fas', open ? 'angle-down' : 'angle-up']" class="h-3 w-3 ml-1" />
        </button>
        <Transition
            name="accordion"
            v-on:before-enter="beforeEnter" v-on:enter="enter"
            v-on:before-leave="beforeLeave" v-on:leave="leave">
            <div v-show="open" class="accordion-content px-4 pt-2">
                <slot></slot>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
const { title, defaultOpen } = defineProps<{
    title: string
    defaultOpen?: boolean
}>()

const open = ref(defaultOpen ?? true)

const beforeEnter = (el: HTMLElement) => {
    el.style.maxHeight = '0';
    el.style.overflow = 'hidden'
}
const enter = (el: HTMLElement) => {
    el.style.maxHeight = el.scrollHeight + 'px';
    setTimeout(() => {
        el.style.maxHeight = ''
        el.style.overflow = 'unset'
    }, 150)
}
const beforeLeave = (el: HTMLElement) => {
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.overflow = 'hidden'
}
const leave = (el: HTMLElement) => {
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.maxHeight = '0';
}
</script>

<style scoped>
.accordion-content {
    transition: 75ms ease-out;
}
</style>
